import { DestroyRef, inject, Injectable } from '@angular/core';
import { GoogleAnalyticsService } from '@lx/shared/google-analytics';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { QuoteStore } from '../store';
import { GoogleAnalyticsEventEnum } from './google-analytics-event.enum';

/**
 * Service to track view page event when the user navigates to a new page in the Quote Tool Lite
 */
@Injectable({
  providedIn: 'root',
})
export class UpdatedQuoteTrackingService {
  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);
  private readonly quoteStore = inject(QuoteStore);
  private readonly destroyRef = inject(DestroyRef);

  // The action to be tracked when a quote is updated
  private readonly quoteUpdatedAction = 'quote_updated';

  /**
   * It starts tracking quote updates by subscribing to the quote store's updated quote events.
   */
  startTrackingUpdatedQuoteEvent() {
    this.quoteStore.selectionForDataLayer$
      .pipe(
        filter((dataLayer) => {
          return Object.values(dataLayer).some((value) => value !== undefined && value !== null);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.googleAnalyticsService.trackEvent(GoogleAnalyticsEventEnum.QuoteUpdated, this.quoteUpdatedAction);
      });
  }
}
